<template>
    <section>
        <el-row>
            <p>需求单审核人员</p>
            <check-type ref="mychecker1" :my_status="list1" :is_set_direct=true @submitDirect="submitDirect1"></check-type>
        </el-row>

        <el-row>
            <p>采购单审核人员</p>
            <check-type ref="mychecker2" :my_status="list2" :is_set_direct=true @submitDirect="submitDirect2"></check-type>
        </el-row>

        <el-row>
            <p>采购员配置</p>
            <check-type ref="mychecker3" :my_status="list3" :is_set_direct=true @submitDirect="setPurchasePerson" :is_only_one="true" :label_text="'采购员'"></check-type>
        </el-row>
        <el-row>
            <p>自购验收人配置</p>
            <check-type ref="mychecker5" :my_status="list5" :is_set_direct=true @submitDirect="setEasyPerson" :is_only_one="true" :label_text="'简易采购验收'"></check-type>
        </el-row>
        <el-button type="primary" @click="put" style="margin:20px;">提交</el-button>
    </section>
</template>

<script>
import checkType from "@/components/mission/checkType.vue";
import { order_setting } from "@/api/server";
import { aps_setting,aps_easy} from "@/api/purchase";

export default {
    data () {
        return{
            list1:[],
            list2:[],
            list3:[],
            list5:[],
            putlist1:[],
            putlist2:[],
            putlist3:[],
            putlist5:[],
            id_one:null,
            id_two:null,
        }
    },
    components:{checkType},

    methods:{
        put(){

        },
        submitDirect1(data){
            this.putlist1=data;
            // this.$confirm('确定要提交吗?', '提示', {
            //     confirmButtonText: '确 定',
            //     cancelButtonText: '取 消',
            //     type: 'warning'
            // }).then(() => {
            //     this.setCheckList(1,data[0]);
            // }).catch(() => {   
            //     this.getCheckList(1)         
            // });
        },
        submitDirect2(data){
             this.putlist2=data;
            // this.$confirm('确定要提交吗?', '提示', {
            //     confirmButtonText: '确 定',
            //     cancelButtonText: '取 消',
            //     type: 'warning'
            // }).then(() => {
            //     this.setCheckList(2,data[0]);
            // }).catch(() => {   
            //     this.getCheckList(2)              
            // });
        },
        // 设置审批员
        setCheckList(val,data){
            let plist1=data;
            // 配置需求审批
            let param1={
                id:val==1?this.id_one:this.id_two,
                action_type:val==1?'APS_CHECK':'PURCHASE_CHECK',
                title:val==1?'需求物资审核配置':'采购物资审核配置',
                sub_states:[],
            }
            param1.sub_states=plist1.sub_status.map((v,i)=>{
                return{
                    name:v.name,
                    index:i,
                    check_type:v.type==1?'ALL':'OR',
                    checker_ids:v.checkers,
                }
            })
            order_setting.setCheck(param1).then(res=>{
                if(res.data){
                    this.$message({message:val==1?'需求审核员设置成功！':'采购审核员设置成功！',type:'success'});
                    val==1?this.putlist1=[]:this.putlist2=[];
                }
                this.getCheckList(val);
            })
        },
        // 获取审核人员
        getCheckList(val){
            let type=val==1?'APS_CHECK':'PURCHASE_CHECK'
            if(val==1){
                this.list1=[];
            }else{
                this.list2=[];
            }
            let promise=order_setting.findCheckSettingList({type:type,page:1,size:1});
            promise.then(res=>{
                if(res.data){
                    let dataList=res.data.list
                    dataList.forEach(r => {
                        this.id_one=val==1?r.id:this.id_one;
                        this.id_two=val==2?r.id:this.id_two;
                        let items=r.sub_states.map(z=>{
                            return{
                                name:z.name,
                                index:z.index,
                                type:z.check_type=='OR'?0:1,
                                checker_name:z.checkers,
                                checkers:z.checkers.map(x=>x.user_id)
                            }
                        })
                        if(val==1){
                            this.list1=items;
                            this.$nextTick(r=>{
                                this.$refs.mychecker1.getMyStatus();
                            })
                        }else{
                            this.list2=items;
                            this.$nextTick(r=>{
                                this.$refs.mychecker2.getMyStatus();
                            })
                        }
                    });
                }
            });
        },

        put(){
            this.$confirm('确定要提交吗?', '提示', {
                confirmButtonText: '确 定',
                cancelButtonText: '取 消',
                type: 'warning'
            }).then(() => {
                this.putlist1.length>0?this.setCheckList(1,this.putlist1[0]):'';
                this.putlist2.length>0?this.setCheckList(2,this.putlist2[0]):'';
                if(this.putlist3.length>0)
                {
                    let plist3=this.putlist3[0];
                    let user_ids=plist3.sub_status&&plist3.sub_status.length>0?plist3.sub_status[0].checkers:[];
                    aps_setting.set({user_id:user_ids}).then(res=>{
                        this.$message({message:'采购员设置成功！',type:'success'});
                        this.putlist3=[];
                        this.getPurchasePerson();
                    })
                }
                if(this.putlist5.length>0)
                {
                    let plist5=this.putlist5[0];
                    let user_ids=plist5.sub_status&&plist5.sub_status.length>0?plist5.sub_status[0].checkers:[];
                    aps_easy.setMan({user_id:user_ids}).then(res=>{
                        this.$message({message:'自购验收人设置成功！',type:'success'});
                        this.putlist5=[];
                        this.getEasyPerson();
                    })
                }
            }).catch(() => { 
                this.putlist1=[];
                this.putlist2=[];
                this.putlist3=[];
                this.putlist5=[];
                this.getCheckList(1);
                 this.getPurchasePerson();
                 this.getCheckList(2); 
                 this.getEasyPerson();      
            });
        },
        // 配置采购员
        setPurchasePerson(data){
            this.putlist3=data;
            // this.$confirm('确定要提交吗?', '提示', {
            //     confirmButtonText: '确 定',
            //     cancelButtonText: '取 消',
            //     type: 'warning'
            // }).then(() => {
            //     let plist3=data[0];
            //     let user_ids=plist3.sub_status&&plist3.sub_status.length>0?plist3.sub_status[0].checkers:[];
            //     aps_setting.set({user_id:user_ids}).then(res=>{
            //         this.$message({message:'设置成功！',type:'success'});
            //         this.getPurchasePerson();
            //     })
            // }).catch(() => {   
            //     this.getPurchasePerson();         
            // });
        },
        //配置简易采购验收人员
        setEasyPerson(data){
            this.putlist5=data;
        },
        // 获取采购员
        getPurchasePerson(){
            this.list3=[];
            aps_setting.get().then(res=>{
                if(res.data){
                    this.list3=[
                        {
                            name:'',
                            index:0,
                            type:null,
                            checker_name:res.data,
                            checkers:res.data.map(x=>x.user_id)
                        }
                    ]
                    this.$nextTick(r=>{
                        this.$refs.mychecker3.getMyStatus();
                    })
                }
            })
        },
        //获取简易采购验收人
        getEasyPerson(){
            aps_easy.getMan().then(res=>{
                if(res.data)
                {
                    this.list5=[
                        {
                            name:'',
                            index:0,
                            type:null,
                            checker_name:res.data,
                            checkers:res.data.map(x=>x.user_id)
                        }
                    ]
                    this.$nextTick(r=>{
                        this.$refs.mychecker5.getMyStatus();
                    })
                }
            })
        },
    },
    mounted(){
        this.getCheckList(1);
        this.getCheckList(2);
        this.getPurchasePerson();
        this.getEasyPerson();
    }
}
</script>

<style scoped lang="scss">
.el-row{
    padding:20px;
    margin:0;
}
p{
    margin:20 0;
    color: #000000;
    font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/views/purchase_apply/staff.vue